import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";
import { serialize } from "object-to-formdata";

export default function useArtworkCategories() {
  const artworkCategories = ref({});
  const artworkCategory = ref({});
  const artworkCategoryMeta = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getArtworkCategories = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_parent = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10,
    onlyActiveArt=0
  ) => {
    axiosClient
      .get(
        "/artwork-categories" +
          "?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_parent=" +
          search_parent +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page+
          "&onlyActiveArt=" +
          onlyActiveArt
      )
      .then((response) => {
        artworkCategories.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getArtworkCategory = async (id) => {
    await axiosClient.get("/artwork-categories/" + id).then((response) => {
      artworkCategory.value = response.data.data;
      artworkCategoryMeta.value = response.data.meta;
    });
  };

  const storeArtworkCategory = async (artworkCategory) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let params = serialize(artworkCategory, {
      indices: true,
      booleansAsIntegers: true,
    });

    axiosClient
      .post("/artwork-categories", params)
      .then((response) => {
        router.push({ name: "artwork-categories.index" });
        swal({
          icon: "success",
          title: "Category saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateArtworkCategory = async (artworkCategory) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let params = serialize(artworkCategory, {
      indices: true,
      booleansAsIntegers: true,
    });

    axiosClient
      .put("/artwork-categories/" + artworkCategory.id, artworkCategory)
      .then((response) => {
        router.push({ name: "artwork-categories.index" });
        swal({
          icon: "success",
          title: "Category saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteArtworkCategory = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/artwork-categories/" + id)
          .then((response) => {
            getArtworkCategories();
            router.push({ name: "artwork-categories.index" });
            swal({
              icon: "success",
              title: "Category deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: "Something went wrong",
            });
          });
      }
    });
  };

  const getArtworkCategoryMeta = async () => {
    axiosClient.get("/artwork-categories/meta").then((response) => {
      artworkCategoryMeta.value = response.data.meta;
    });
  };

  return {
    artworkCategories,
    artworkCategory,
    getArtworkCategories,
    getArtworkCategory,
    storeArtworkCategory,
    validationErrors,
    isLoading,
    updateArtworkCategory,
    deleteArtworkCategory,
    getArtworkCategoryMeta,
    artworkCategoryMeta,
  };
}
